import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET004_Request,
  IAPI_RET004_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_RET020_Request,
  IAPI_RET020_Response,
  IAPI_RET021_Request,
  IAPI_RET021_Response,
  IAPI_STA039_Request,
  IAPI_STA039_Response,
  IAPI_COM014_Request,
  IAPI_COM014_Response
} from "../../../type/apiType";

// 退職手当金請求参照
const httpAPI_RET004 = async (
  param: IAPI_RET004_Request
): Promise<IAPI_RET004_Response> => {
  let res = await http.post(ApiUrl.API_RET004, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 退職手当金請求更新(削除書類)
const httpAPI_RET021 = async (
  param: IAPI_RET021_Request
): Promise<IAPI_RET021_Response> => {
  let res = await http.post(ApiUrl.API_RET021, {
    ...param,
  });
  return res.data;
};

// 退職手当金請求更新(追加・更新書類)
const httpAPI_RET020 = async (
  param: IAPI_RET020_Request
): Promise<IAPI_RET020_Response> => {
  let res = await http.post(ApiUrl.API_RET020, {
    ...param,
  });
  return res.data;
};

// 源泉徴収票参照API
const httpAPI_STA039 = async (
  param: IAPI_STA039_Request
): Promise<IAPI_STA039_Response> => {
  let res = await http.post(ApiUrl.API_STA039, {
    ...param,
  });
  return res.data;
};
// ファイルダウンロード
const httpAPI_COM014 = async (
  param: IAPI_COM014_Request
): Promise<IAPI_COM014_Response> => {
  let res = await http.post(ApiUrl.API_COM014, {
    ...param,
  });
  return res.data;
};

export {
  httpAPI_RET004,
  httpAPI_APP016,
  httpAPI_RET021,
  httpAPI_RET020,
  httpAPI_STA039,
  httpAPI_COM014,
};
